document.addEventListener("DOMContentLoaded", function () {
  const slidingCardSwipers = document.querySelectorAll(
    ".sliding-cards-capabilities .card-swiper",
  );

  if (slidingCardSwipers.length > 0) {
    slidingCardSwipers.forEach((cardSwiper) => {
      const swiperId = cardSwiper.dataset.unique;

      const servicesSwiper = new Swiper(
        `.card-swiper[data-unique=${swiperId}]`,
        {
          // Optional parameters
          loop: true,
          slidesPerView: "auto",
          slidesPerViewAutoSlideSize: 500,
          spaceBetween: 30,
          autoplay: false,
          allowTouchMove: true, // Enable touch/swipe gestures
          speed: 800,
          navigation: {
            nextEl: `.sliding-cards-capabilities .swiper-controls[data-controls=${swiperId}] .next`,
            prevEl: `.sliding-cards-capabilities .swiper-controls[data-controls=${swiperId}] .prev`,
          },
        },
      );
    });
  }
});
